import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import {
  apiPartiesDetailGet,
  apiPartiesListGet,
} from '@/entities/parties/modules/api/parties';
import type { ApiPartiesListParams } from '@/shared/types/api/parties';

export const usePartiesList = (params: ApiPartiesListParams) =>
  useFetch({
    api: () => apiPartiesListGet(params),
    keywords: queryKeys.parties.list(params),
    staleTime: 60_000,
  });

export const usePartyDetail = (id: string | undefined) =>
  useFetch({
    api: () => apiPartiesDetailGet(id ?? ''),
    keywords: queryKeys.parties.detail(id ?? ''),
    enabled: Boolean(id),
    staleTime: 30_000,
  });
